<template>
	<div>
		<!-- <top></top> -->
		<div class="conmtont">
			<div class="flex align-center justify-between padding-sm bg-white margin-tb">
				<!-- <p class="text-sm text-666">首页 - 技能培训</p>
				<p class="flex align-center text-999 text-sm pointer" @click="back()">
					<i class="el-icon-back"></i>
					<span>返回</span>
				</p> -->
				<el-breadcrumb separator-class="el-icon-minus">
				  <el-breadcrumb-item :to="{ path: '/' }"><span class="text-sm text-666">首页</span></el-breadcrumb-item>
				  <el-breadcrumb-item><span class="text-sm text-666">技能培训</span></el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="bg-white padding-sm margin-bottom-sm">
				<div class="flex align-center margin-bottom-sm">
					<p class="type-btn text-xs margin-right-sm pointer" :class="type == 1?'bg-theme text-white':''" @click="chose(1)">免费公开课</p>
					<p class="type-btn text-xs margin-right-sm pointer" :class="type == 2?'bg-theme text-white':''" @click="chose(2)">精品课程</p>
				</div>
				<div class="flex margin-bottom-sm">
					<p class="titla text-left text-xs text-666">专业分类：</p>
					<p>
						<span class="margin-right-sm  text-xs pointer pro-item" @click="choseclass(item)" :class="category_id == item.id?'text-theme':'text-666'" v-for="(item,index) in profession" :key="index">{{item.category_name}}</span>
					</p>
				</div>
				<div class="flex margin-bottom-sm">
					<p class="titla text-left text-xs text-666">课程类型：</p>
					<p>
						<span class="margin-right-sm  text-xs pointer pro-item" @click="choselesson(item)" :class="lessonindex == item.id?'text-theme':'text-666'" v-for="(item,index) in lessontype" :key="index">{{item.name}}</span>
					</p>
				</div>
				<div class="flex">
					<p class="titla text-left text-xs text-666">排序方式：</p>
					<p>
						<span class="margin-right-sm  text-xs pointer pro-item" @click="chosesort(item)" :class="sortindex == item.id?'text-theme':'text-666'" v-for="(item,index) in sort" :key="index">{{item.name}}</span>
					</p>
				</div>
			</div>
			<div v-if="total != 0">
				<el-row :gutter="15">
					<el-col :span="12"  v-for="(item,index) in skillList" :key="index"><SkillList :data="item" :type="type" :size="24"></SkillList></el-col>
				</el-row>
				<div class="pagination">
					<el-pagination
						@current-change="handleCurrentChange"
					  background
					  page-size="10"
					  layout="prev, pager, next"
					  prev-text="上一页"
					  next-text="下一页"
					   :total="total">
					</el-pagination>
				</div>
			</div>
			<div class="text-center" v-else>
				<el-empty description="暂无数据"></el-empty>
			</div>
		</div>
		<router-view />
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	import Top from '@/components/public/top.vue';
	import SkillList from '@/components/list/skill-list.vue';
	export default {
		components: {
			Top,
			SkillList
		},
		name: '',

		data() {
			return {
				profession:[],//分类
				category_id:0,//选择得分类id
				lessontype:[
					{
						id: 0,
						name: '视频课程',
					},
					{
						id: 1,
						name: '文件课程',
					},
				],//课程类型
				lessonindex:0,//0 视频 1 文件
				sort:[
					
					{
						id: 1,
						name: '默认排序',
					},
					{
						id: 2,
						name: '最新排序',
					},
				],//排序方式
				sortindex:0,//1 默认 2 最新
				type:1,//1  免费    2   精品
				skillList:[],//列表
				page:1,
				total:0,//
			}
		},
		created() {
			//通知听不状态栏 选中的页面
			Bus.$emit('chosename','skill')
			this.getgory()
			this.getSkillList()
		},
		methods: {
			back(){
				this.$router.back()
			},
			chose(type){
				this.type = type
				this.getSkillList()
			},
			/**
			 * 分类筛选
			 * */
			choseclass(item){
				this.category_id = item.id
				this.getSkillList()
			},
			//类型筛选
			choselesson(item){
				this.lessonindex = item.id
				this.getSkillList()
			},
			//排序筛选
			chosesort(item){
				this.sortindex = item.id
				this.getSkillList()
			},
			getgory(){
				this.ajax('get', '/api/courseCateGory/getList', {
					type:1,
				}, res => {
					if(res.status == 200){
						let info = {
							category_name:'全部',
							id:0
						}
						res.data.unshift(info)
						console.log(res.data);
						this.profession = res.data
					}
				})
			},
			handleCurrentChange: function(currentPage) {
			  this.page = currentPage;
			  this.getSkillList();
			},
			getSkillList(){
				this.ajax('get', '/api/course/getList', {
					type:this.lessonindex,
					sort:this.sortindex,
					category_id:this.category_id,
					is_free:this.type,
					page:this.page,
				}, res => {
					if(res.status == 200){
						this.skillList = res.data.data
						if(this.page == 1){
							this.total =  Number(res.data.lastpage) * Number(res.data.data.length)
						}
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.type-btn{
		width: 96px;
		height: 35px;
		line-height: 35px;
		background: #F5F5F7;
		border-radius: 18px;
	}
	/deep/ .el-pagination.is-background .btn-next,/deep/ .el-pagination.is-background .btn-prev,/deep/ .el-pagination.is-background .el-pager li{
		background: #fff !important;
	}
	/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
		background:#09827B !important;
		color: #fff !important;
	}
	/deep/ .el-pagination.is-background .btn-prev,/deep/ .el-pagination.is-background .btn-next{
		padding: 0 10px;
	}
	
	.pagination{
		margin: 59px 0;
	}
</style>



// WEBPACK FOOTER //
// src/view/index/skill.vue